import { render, staticRenderFns } from "./RsaAssegnaPostoLettoModalEditComponent.vue?vue&type=template&id=1b1fc37c"
import script from "./RsaAssegnaPostoLettoModalEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaAssegnaPostoLettoModalEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports